import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyCheckInTasks({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <path id="pic-empty-check-in-tasks_svg__c" d="M6 6.38l4.31 4.3L18 3" />
        <path id="pic-empty-check-in-tasks_svg__d" d="M6 6.38l4.31 4.3L18 3" />
        <filter
          x="-7.6%"
          y="-5%"
          width="115.2%"
          height="114%"
          filterUnits="objectBoundingBox"
          id="pic-empty-check-in-tasks_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="pic-empty-check-in-tasks_svg__b" y={12} width={92} height={100.23} rx={4} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M174.9 147.5c-42.86 4.43-60.36 17.5-100.9 15.93-47.85-1.86-89.92-36.47-66.05-74.93C26.15 59.16 55.25 59.16 108 19c72.8-55.42 201.9 114.55 66.9 128.5z"
          fill="#E9EDFB"
        />
        <path
          d="M233.5 105.5l-.28 1.96c-3.43 20-20.52 36.13-58.32 40.04-42.86 4.43-60.36 17.5-100.9 15.93-47.85-1.86-89.92-36.47-66.05-74.93l.08-.13C23.78 101.46 46.1 108 75 108c57.05 0 72.06-14.69 117.73-21 21.04-2.9 34.63 3.26 40.77 18.5z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(74 33)">
          <use
            fill="#000"
            filter="url(#pic-empty-check-in-tasks_svg__a)"
            xlinkHref="#pic-empty-check-in-tasks_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-check-in-tasks_svg__b" />
        </g>
        <path
          d="M129.24 33a2 2 0 012 2v8.1h18.37a2 2 0 011.9 1.37l1.68 5.1a2 2 0 01-1.9 2.63H88a2 2 0 01-1.9-2.62l1.68-5.1a2 2 0 011.9-1.38h19.12V35c0-1.1.9-2 2-2h18.44zm-9.22 4.49a2.24 2.24 0 100 4.49 2.24 2.24 0 000-4.5z"
          fill="#8F9DD6"
        />
        <g transform="translate(84 102)">
          <rect fill="#E3E8E8" x={26} y={1} width={41} height={5} rx={1} />
          <rect fill="#E3E8E8" x={26} y={11} width={24} height={5} rx={1} />
          <rect stroke="#E3E8E8" strokeWidth={2} x={1} y={1} width={16} height={16} rx={4} />
          <g strokeLinecap="round" strokeLinejoin="round">
            <use stroke="#FFF" strokeWidth={8} xlinkHref="#pic-empty-check-in-tasks_svg__c" />
            <use stroke="#FB8F23" strokeWidth={3} xlinkHref="#pic-empty-check-in-tasks_svg__c" />
          </g>
        </g>
        <g transform="translate(84 65)">
          <rect fill="#E3E8E8" x={26} y={1} width={41} height={5} rx={1} />
          <rect fill="#E3E8E8" x={26} y={11} width={41} height={5} rx={1} />
          <rect fill="#E3E8E8" x={26} y={21} width={24} height={5} rx={1} />
          <rect stroke="#E3E8E8" strokeWidth={2} x={1} y={1} width={16} height={16} rx={4} />
          <g strokeLinecap="round" strokeLinejoin="round">
            <use stroke="#FFF" strokeWidth={8} xlinkHref="#pic-empty-check-in-tasks_svg__d" />
            <use stroke="#FB8F23" strokeWidth={3} xlinkHref="#pic-empty-check-in-tasks_svg__d" />
          </g>
        </g>
        <g transform="translate(147 107)">
          <circle fill="#6C7EC9" cx={28} cy={28} r={28} />
          <g fill="#FFF">
            <path d="M28.9 18.26v19.81L18.07 36.1V20.23l10.81-1.97m.82-2.24l-12.45 2.26c-.69 0-1.24.91-1.24 2.03v15.71c0 1.12.55 2.03 1.24 2.03l12.45 2.26c.68 0 1.24-.9 1.24-2.02V18.04c0-1.12-.56-2.02-1.24-2.02z" />
            <path d="M24.81 28.17a1.42 1.42 0 102.84 0 1.42 1.42 0 10-2.84 0zm7.2.64l3.6 3.55c.32.33.86.34 1.19 0a.85.85 0 00.01-1.2l-2.15-2.15h4.72a.85.85 0 000-1.7h-4.72l2.18-2.14a.85.85 0 10-1.2-1.2L32 27.57a.85.85 0 000 1.24zm5.76 4.97V36c0 .53-.43.95-.95.95h-2.9a.93.93 0 100 1.86h2.9a2.8 2.8 0 002.8-2.8v-2.23h-1.85zm-3.85-13.63h2.9c.52 0 .94.42.95.95v1.45h1.85V21.1a2.8 2.8 0 00-2.8-2.8h-2.9a.93.93 0 100 1.85z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyCheckInTasks.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyCheckInTasks.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyCheckInTasks svgRef={ref} {...props} />
));
export default ForwardRef;
